import {FcmService} from './fcm.service';

export const FcmInjectables: Array<any> = [
  {
    provide: FcmService,
    useClass: FcmService,
  },
];
